import React, { FC, useEffect, useRef, useState } from 'react'
import { PopoverPlacements, Tooltip } from '@ui-kitten/components'
import { InfoIcon } from '../../assets/icons'
import { BtText } from '@linqpal/components/src/ui'
import { isWeb } from '../../utils/helpers/commonUtils'
import { PopoverPlacement } from '@ui-kitten/components/ui/popover/type'

interface ITooltipIconProps {
  tooltip: any
  title?: string
  tooltipPosition?: PopoverPlacement
  size?: number
}

export const TooltipIcon: FC<ITooltipIconProps> = ({
  tooltip,
  title,
  tooltipPosition,
  size = 12,
}) => {
  const [visible, setVisible] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  // css tooltips from TooltipView behave poorly when overlapped by native elements (zIndex doesn't help)
  // ui kitten doesn't provide built-in mouse-over tooltips
  // mouseLeave event is fired immediately after tooltip is open, so it's useless for hiding tooltip
  const onMouseMove = (event: MouseEvent) => {
    if (anchorRef.current) {
      const x = event.clientX
      const y = event.clientY

      const anchorRect = anchorRef.current.getBoundingClientRect()
      const isInside =
        x >= anchorRect.left &&
        x <= anchorRect.right &&
        y >= anchorRect.top &&
        y <= anchorRect.bottom

      setVisible(isInside)
    }
  }

  useEffect(() => {
    if (isWeb) {
      window.addEventListener('mousemove', onMouseMove)
      return () => {
        window.removeEventListener('mousemove', onMouseMove)
      }
    } else return
  }, [])

  return (
    <div ref={anchorRef}>
      <Tooltip
        anchor={() => (
          <div
            style={{
              cursor: 'pointer',
            }}
          >
            <InfoIcon
              height={size}
              width={size}
              onClick={() => setVisible(true)}
              fill={visible ? '#00A0F3' : '#668598'}
            />
          </div>
        )}
        visible={visible}
        placement={tooltipPosition ?? PopoverPlacements.BOTTOM}
        onBackdropPress={() => setVisible(false)}
        style={{ width: 246, backgroundColor: '#003353' }}
      >
        <div style={{ padding: 5 }}>
          {title ? (
            <div style={{ marginBottom: 5 }}>
              <BtText weight={'700'} style={styles.text}>
                {title}
              </BtText>
            </div>
          ) : null}
          <BtText weight={'400'} style={styles.text}>
            {tooltip}
          </BtText>
        </div>
      </Tooltip>
    </div>
  )
}

const styles = {
  text: {
    fontFamily: 'Inter, sans-serif',
    color: '#FFFFFF',
    fontSize: 14,
  },
}
